import {
  Button,
  Card,
  FlexGrid,
  MenuItem,
  Typography,
  useThemeProvider,
} from '@albo-ui/core';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { usePmStatusQuickWin } from '../../hooks/use-pm-status-quick-win';
import { useUserRole } from '../../hooks/use-user-role';
import { useApi } from '../../providers/api-provider';
import { useAuth } from '../../providers/auth-provider';
import { useTranslator } from '../../providers/translator-provider';
import { OnBoardingLoader } from '../on-boarding-loader';
import { GetMenuItems } from './const';
import { useExternalAuthData } from '../../providers/external-auth-provider';

export const OnBoardingMenuPM = () => {
  const { items } = GetMenuItems();
  const { theme } = useThemeProvider();
  const [api] = useApi();
  const history = useHistory();
  const {
    ON_BOARDING_MENU_TITLE,
    ON_BOARDING_MENU_TEXT,
    SEND_REVISION,
    CONFIRM,
    FINISH
  } = useTranslator();
  const pmStatus = usePmStatusQuickWin();
  const { isOpsAnalyst } = useUserRole();
  const {
    leadData: { uuid, interactionStatus },
    user,
    obtainCredentials
  } = useAuth();

  const buttonEnabled = isOpsAnalyst || (interactionStatus === 'pending-user-approval' && pmStatus.allFormsIsCompleted)
    || pmStatus.readyToSend;
  const [loading, setLoading] = useState(false);
  const { reloadProfile, reloadingProfile } = useAuth();
  const { clearLeadFromAuthData } = useExternalAuthData()

  function onCardClick(url: string) {
    history.push(`record-info/${url}`);
  }

  async function onHandleClick() {
    if (isOpsAnalyst) {
      sendForUserApproval();
      return;
    }

    if (!isOpsAnalyst && interactionStatus === 'pending-user-approval') {
      onConfirmChanges();
      return;
    }

    onSendValidationClick();
  }

  async function onSendValidationClick() {
    setLoading(true);
    await api.callService('send-to-validation', {
      leadUuid: uuid,
      type: 'revision'
    });
    reloadProfile();
    setLoading(false);
  }

  async function sendForUserApproval() {
    setLoading(true);
    await obtainCredentials({ noLead: true });
    clearLeadFromAuthData();
    reloadProfile();
    setLoading(false);
  }

  async function onConfirmChanges() {
    setLoading(true);
    await api.callService('lead-approves-changes', {
      leadUuid: uuid,
      userUuid: user?.userUuid
    });
    await onSendValidationClick();
    reloadProfile();
    setLoading(false);
  }

  const bottonButtonText = isOpsAnalyst ?
    FINISH :
    interactionStatus === 'pending-user-approval'
      ? CONFIRM
      : SEND_REVISION;
  
  if (loading || reloadingProfile)
    return <OnBoardingLoader isLoading={loading || reloadingProfile} />;

  return (
    <FlexGrid
      container
      fullHeight
      fullWidth
      direction='column'
      alignItems='center'
      padding={4}
      spacing={4}
      style={{ overflowY: 'auto', padding: 0 }}
    >
      <FlexGrid item container direction='column' style={{ maxWidth: '633px' }}>
        <FlexGrid
          item
          container
          direction='column'
          spacing={1}
          style={{ paddingTop: theme.spacesPx[4] }}
        >
          <FlexGrid item>
            <Typography variant='smallTitle'>
              {ON_BOARDING_MENU_TITLE}
            </Typography>
          </FlexGrid>
          <FlexGrid item>
            <Typography variant='small'>{ON_BOARDING_MENU_TEXT}</Typography>
          </FlexGrid>
        </FlexGrid>
      </FlexGrid>
      <FlexGrid item container direction='column'>
        <FlexGrid item container direction='column' spacing={2}>
          {items.map(({ icon, title, description, url, status }, index) => (
            <FlexGrid item key={index}>
              <MenuItem
                key={index}
                title={title}
                description={description}
                icon={icon}
                status={status as keyof typeof theme.statusCardColors}
                onClick={() => onCardClick(url)}
              />
            </FlexGrid>
          ))}
        </FlexGrid>
      </FlexGrid>
      <FlexGrid item fullWidth style={{ marginTop: 'auto' }}>
        <Card
          fullWidth
          style={{ borderColor: theme.colors.manatee, borderRadius: 0 }}
          alignItems='center'
          justifyContent='flex-end'
        >
          <Button
            onClick={onHandleClick}
            size='large'
            disabled={!buttonEnabled}
          >
            {bottonButtonText}
          </Button>
        </Card>
      </FlexGrid>
    </FlexGrid>
  );
};
